import styled from "styled-components";
import { Text4 } from "../../Common";



export const GridWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: space-around;
`;


export const GridWrapperOne = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const GridWrapperTwo = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`


export const CardWrapper = styled.div`
  ${(props) => props.gridColumn && `grid-column: ${props.gridColumn}`};
  ${(props) => props.gridRow && `grid-row: ${props.gridRow}`};

  @media screen and (max-width: 1020px) {
    grid-column: auto;
    grid-row: auto;
  }

  @media screen and (max-width: 768px) {
    grid-column: auto;
    grid-row: auto;
  }
`;

export const CardContentWrapper = styled.div`
  background-color: #262636;
  width: 100%;
  border-radius: 10px;
  height: 100%;
  min-height: fit-content;
  padding: 20px;
  position: relative;

  .sec1 {
    display: flex;
    gap: 10px;
  }
  img {
    width: ${(props) => (props.imageSize ? `${props.imageSize}px` : "60px")};
    height: ${(props) => (props.imageSize ? `${props.imageSize}px` : "60px")};
    border-radius: 50%;
    @media screen and (max-width: 768px) {
      width: 25px;
      height: 25px;
    }
  }
  .expandIcon {
    width: 15px;
    height: 15px;
    position: absolute;
    bottom : 10px;
    right : 10px;
  }
`;



